import BidModal from './bid-modal';

export default BidModal;
